export const milestoneStatusConstants = [
  { name: "Paid", value: "paid" },
  { name: "Forwarded", value: "forward" },
  { name: "Due", value: "due" },
  { name: "Partial Paid", value: "partial_paid" },
  { name: "Board Created", value: "board_created" },
];
